import React, { ComponentType, PureComponent } from 'react';

import LocaleContext from 'services/LocaleProvider/LocaleContext';

const withLocaleContext = <P extends object>(Component: ComponentType<P>) => {
  class WithLocaleContext extends PureComponent<P> {
    render() {
      return (
        <LocaleContext.Consumer>
          {(value: ILocaleContext) => <Component {...this.props} {...value} />}
        </LocaleContext.Consumer>
      );
    }
  }

  return WithLocaleContext;
};

export default withLocaleContext;
